import { useLayoutEffect, useMemo } from "react";
import { useLocation } from "react-router-dom";
import { capturePerformanceNavigation, commitMilestone, commitVerifiedMilestone, type Milestone, type VerifiedMilestone } from "./performanceDiagnostics";

/** Marco de commit, nao tempo CPU do React. O coletor deduplica por navegacao. */
export function usePerformanceMilestone(phase: Exclude<Milestone, VerifiedMilestone>, ready = true) {
  useLayoutEffect(() => { if (ready) commitMilestone(phase); });
}

/** Contexto/qualidade sao verificados pelo chamador; token impede commit de outra navegacao. */
export function useVerifiedPerformanceMilestone(phase: VerifiedMilestone, ready: boolean, expectedPath: string) {
  const location = useLocation();
  const context = useMemo(() => ({
    routeKey: location.key, token: capturePerformanceNavigation(expectedPath),
  }), [expectedPath, location.key]);
  useLayoutEffect(() => { if (ready) commitVerifiedMilestone(context.token, phase); }, [phase, ready, context]);
}
